import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import DashboardWidget from "../../../atoms/DashboardWidget";
import {
  Layers,
  Users,
  ListTodo,
  FileChartColumnIncreasing,
  Contact,
  FileClock,
  ClockAlert,
} from "lucide-react";
import GraphContainer from "./GraphContainer";
import { useSelector } from "react-redux";
import { getData } from "../../../../services";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const [cookies] = useCookies([]);
  const [tableData, setTableData] = useState([]);

  const getDashboardData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: isAdmin
          ? "Dashboard/getAdminDashboardCount"
          : "Dashboard/getEmployeeDashboardCount",
        params: {
          // search_query: searchedValue,
          // page: currentPage,
          // page_limit: itemsPerPage,
          // business_id: cookies.bid,
          emp_id: isAdmin ? null : cookies.euid,
          business_id: cookies.buid,
          api_version: null,
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    }
  }, [cookies.e_t]);

  useEffect(() => {
    if (accessData) {
      getDashboardData();
    }
  }, [getDashboardData, isAdmin]);

  return (
    <div className="main-container">
      <div
        className={`${styles.widget_container} ${
          isAdmin ? styles.admin : styles.nonAdmin
        }`}
      >
        {isAdmin && (
          <>
            <DashboardWidget
              title={"Total Employees"}
              count={tableData?.employee_count || 0}
              icon={<Users size={22} color="#6C5DD3" />}
              onClick={() => navigate("/dashboard/employees")}
            />
            <DashboardWidget
              title={"Total Clients"}
              count={tableData?.client_count || 0}
              icon={<Contact size={22} color="#6C5DD3" />}
              onClick={() => navigate("/dashboard/clientmanagement")}
            />
          </>
        )}

        <DashboardWidget
          title={"Total Projects"}
          count={tableData?.project_count || 0}
          icon={<Layers size={22} color="#6C5DD3" />}
          onClick={() => navigate("/dashboard/projects")}
        />

        <DashboardWidget
          title={"Completed Tasks"}
          count={tableData?.completed_task || 0}
          icon={<ListTodo size={22} color="#6C5DD3" />}
          onClick={() => navigate('/dashboard/tasks?status=["Completed"]')}
        />
        <DashboardWidget
          title={"Pending Tasks"}
          count={tableData?.pending_task || 0}
          icon={<FileChartColumnIncreasing size={22} color="#6C5DD3" />}
          onClick={() =>
            navigate('/dashboard/tasks?status=["New Task","In Progress"]')
          }
        />

       <DashboardWidget
          title={"Delayed Tasks"}
          count={tableData?.delay_task_count || 0}
          icon={<FileClock  size={22} color="#6C5DD3" />}
          onClick={() =>
            navigate('/dashboard/tasks?delayed=["delayed"]')
          }
        />

       <DashboardWidget
          title={"Overdue Tasks"}
          count={tableData?.overdue_task_count || 0}
          icon={<ClockAlert size={22} color="#6C5DD3"  />}
          onClick={() =>
            navigate('/dashboard/tasks?delayed=["duepast"]')
          }
        />

        <DashboardWidget
          title={"My Pending Tasks"}
          count={tableData?.employee_pending_task_count || 0}
          icon={<ClockAlert size={22} color="#6C5DD3" />}
          onClick={() =>
            navigate('/dashboard/my-tasks?status=["New Task","In Progress"]')
          }
        />

        
      </div>

      <GraphContainer />
    </div>
  );
};

export default Home;
